import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
  blockEditor: { MediaUpload, MediaUploadCheck },
  components: { PanelBody, Button, ToggleControl },
} = wp;

const BackgroundVideo = ({ backgroundVideoOptions, setAttributes }) => {
  const onChangeVideoUpload = (url, filename, paramBackgroundVideoOptions) => {
    setAttributes({
      backgroundVideoOptions: {
        ...paramBackgroundVideoOptions,
        video: {
          ...paramBackgroundVideoOptions.video,
          source: url,
          filename,
        },
      },
    });
  };

  const onChangeMobileImage = (url, alt, paramBackgroundVideoOptions) => {
    setAttributes({
      backgroundVideoOptions: {
        ...paramBackgroundVideoOptions,
        mobileImage: {
          url,
          alt,
        },
      },
    });
  };

  const { video, mobileImage } = backgroundVideoOptions;
  return (
    <>
      <PanelBody title={__('Background Video Options')} initialOpen={true}>
        <MediaUploadCheck>
          <MediaUpload
            allowedTypes={['video']}
            value={video?.source}
            onSelect={(video) => {
              const { filename, url } = video;
              onChangeVideoUpload(url, filename, backgroundVideoOptions);
            }}
            render={({ open }) => (
              <div className="media-upload video-upload">
                {video?.source && (
                  <div className="upload-buttons-wrapper">
                    <MediaReplaceButton onClick={open} />
                    <MediaRemoveButton
                      onClick={() => {
                        onChangeVideoUpload('', '', backgroundVideoOptions);
                      }}
                    />
                  </div>
                )}
                {!video?.source && (
                  <Button className="media-button upload-button" onClick={open}>
                    {__('Upload Video', 'berg')}
                  </Button>
                )}
                <div className="video-file-name">
                  <p>{video?.filename}</p>
                </div>
              </div>
            )}
          ></MediaUpload>
        </MediaUploadCheck>
        {video?.source && (
          <>
            <ToggleControl
              label={__('Show Controls')}
              checked={video?.showControls}
              onChange={(showControls) => {
                setAttributes({
                  backgroundVideoOptions: {
                    ...backgroundVideoOptions,
                    video: {
                      ...backgroundVideoOptions.video,
                      showControls,
                    },
                  },
                });
              }}
            />
            <ToggleControl
              label={__('Auto Play')}
              checked={video?.autoPlay}
              onChange={(autoPlay) => {
                setAttributes({
                  backgroundVideoOptions: {
                    ...backgroundVideoOptions,
                    video: {
                      ...backgroundVideoOptions.video,
                      autoPlay,
                    },
                  },
                });
              }}
            />
            <ToggleControl
              label={__('Loop')}
              checked={video?.loop}
              onChange={(loop) => {
                setAttributes({
                  backgroundVideoOptions: {
                    ...backgroundVideoOptions,
                    video: {
                      ...backgroundVideoOptions.video,
                      loop,
                    },
                  },
                });
              }}
            />
            <ToggleControl
              label={__('Mute')}
              checked={video?.mute}
              onChange={(mute) => {
                setAttributes({
                  backgroundVideoOptions: {
                    ...backgroundVideoOptions,
                    video: {
                      ...backgroundVideoOptions.video,
                      mute,
                    },
                  },
                });
              }}
            />
          </>
        )}

        <hr />
        <p>Mobile Image</p>
        <MediaUploadCheck>
          <MediaUpload
            allowedType={['image']}
            value={mobileImage?.url}
            onSelect={(img) => {
              const { url = '', alt = '' } = img;
              onChangeMobileImage(url, alt, backgroundVideoOptions);
            }}
            render={({ open }) => (
              <div className="media-upload image-upload">
                {mobileImage?.url && (
                  <div className="upload-buttons-wrapper">
                    <MediaReplaceButton onClick={open} />
                    <MediaRemoveButton
                      onClick={() => {
                        onChangeMobileImage('', '', backgroundVideoOptions);
                      }}
                    />
                  </div>
                )}
                {!mobileImage?.url && (
                  <Button className="media-button upload-button" onClick={open}>
                    {__('Upload Image', 'b3rg')}
                  </Button>
                )}
                {mobileImage?.url && (
                  <div
                    className="image-thumb-wrapper"
                    onClick={open}
                    onKeyUp={open}
                    role="button"
                    tabIndex="0"
                  >
                    <img
                      className="image-thumb"
                      src={mobileImage?.url}
                      alt={mobileImage?.alt}
                    />
                  </div>
                )}
              </div>
            )}
          ></MediaUpload>
        </MediaUploadCheck>
      </PanelBody>
    </>
  );
};

export default BackgroundVideo;
